(() => {
  const script = document.currentScript;
  const destination = script.dataset.landerUrl;
  const storeHost = script.dataset.storeHost;

  function updateLinks(root) {
    const links = root.matches?.('a[href]') ? [root] : [];
    links.push(...root.querySelectorAll('a[href]'));
    links.forEach(link => {
      const url = new URL(link.href, location.href);
      if (![location.hostname, storeHost].includes(url.hostname)) return;
      if (!/(^|\/)(collections|products)(\/|$)/.test(url.pathname)) return;
      link.setAttribute('href', destination);
    });
  }

  updateLinks(document);
  new MutationObserver(records => {
    records.forEach(record => {
      if (record.type === 'attributes') updateLinks(record.target);
      record.addedNodes.forEach(node => {
        if (node.nodeType === Node.ELEMENT_NODE) updateLinks(node);
      });
    });
  }).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['href']
  });
})();
